import axios from "../index";

const getAll = query => {
    return axios.get(`all-athletes${query}`)
}

export default {getAll}